import {isAppControllerData} from '../tpa/installedTpaAppsUtils'
import type {AppDefinitionId, DataItem} from '@wix/document-services-types'
export const getControllerAppDefinitionId = (controllerData: DataItem): AppDefinitionId | undefined => {
    if (isAppControllerData(controllerData)) {
        return controllerData?.applicationId as AppDefinitionId
    }
}
